import { Conduit } from '@campingvision/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}booking/reminders/`,
  [],
  [authentication],
  [],
  false,
  3 * 60 * 1000,
  true,
);

export default {
  /**
   * @param domainId
   * @return AxiosPromise
   */
  getTemplates(domainId) {
    return conduit.get(`templates/domains/${domainId}/with-attachments`);
  },

  /**
   * @param template
   * @return AxiosPromise
   */
  createTemplate(template) {
    return conduit.post(`templates/domains/${template.domainId}/create`, template);
  },

  /**
   * @param template
   * @return AxiosPromise
   */
  editTemplate(template) {
    return conduit.put(`templates/domains/${template.domainId}/update`, template);
  },

  /**
   * @param domainId
   * @param revision
   * @return AxiosPromise
   */
  getRulesForDomain(domainId, revision) {
    if (revision) {
      return conduit.get(`rules/domains/${domainId}?revision=${revision}`);
    }
    return conduit.get(`rules/domains/${domainId}`);
  },

  /**
   * @param domainId
   * @param templates
   * @return AxiosPromise
   */
  createRevision(domainId, templates) {
    return conduit.post(`rules/domains/${domainId}/create`, { templates });
  },

  /**
   * @param domainId
   * @return AxiosPromise
   */
  getRevisions(domainId) {
    return conduit.get(`rules/domains/${domainId}/revisions`);
  },

  /**
   * @return AxiosPromise
   */
  getPreviewData() {
    return conduit.get('lists/preview');
  },

  /**
   * @return AxiosPromise
   */
  getOverview() {
    return conduit.get('lists/overview');
  },

  /**
   * @param list
   * @return AxiosPromise
   */
  getList(list) {
    return conduit.get(`lists/${list}`);
  },

  /**
   * @param bookingId
   * @return AxiosPromise
   */
  getPaymentMessages(bookingId) {
    return conduit.get(`lists/booking/${bookingId}/payment-messages`);
  },

  /**
   * @param domainId
   * @return AxiosPromise
   */
  getSettings(domainId) {
    return conduit.get(`rules/domains/${domainId}/settings`);
  },

  /**
   * @param domainId
   * @param setting
   * @return AxiosPromise
   */
  createSetting(domainId, setting) {
    return conduit.post(`rules/domains/${domainId}/settings/create`, setting);
  },

  /**
   * @param domainId
   * @param setting
   * @return AxiosPromise
   */
  updateSetting(domainId, setting) {
    return conduit.put(`rules/domains/${domainId}/settings/${setting.id}/update`, setting);
  },

  /**
   * @param domainId
   * @param setting
   * @return AxiosPromise
   */
  deleteSetting(domainId, setting) {
    return conduit.put(`rules/domains/${domainId}/settings/${setting.id}/delete`, setting);
  },

  /**
   * @param domainId
   * @param setting
   * @return AxiosPromise
   */
  activateSetting(domainId, setting) {
    return conduit.put(`rules/domains/${domainId}/settings/${setting.id}/activate`, setting);
  },

  /**
   * @param domainId
   * @param settingId
   * @return AxiosPromise
   */
  getLogs(domainId, settingId) {
    return conduit.get(`rules/domains/${domainId}/settings/${settingId}/logs`);
  },
};



// WEBPACK FOOTER //
// ./src/services/reminder-service.js